import styles from  './smallLoader.module.scss';

function SmallLoader({ color, visible }) {
  return (
    <div className={styles.loader} style={{ opacity: visible ? 1 : 0, borderColor: `${color ? color : `blue`} transparent`}}></div>
  );
}

export default SmallLoader;